import { render, staticRenderFns } from "./newsPage.vue?vue&type=template&id=64e955c8&"
import script from "./newsPage.vue?vue&type=script&lang=ts&"
export * from "./newsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports